import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { teacherTypography } from '../design/typography';
import { CETELE_TEMPLATES as TEMPLATES } from './ceteleTemplates';

const action = { minHeight: 44, ...teacherTypography.action,
  '&:focus-visible': { outline: '3px solid #352179', outlineOffset: -3 } };

export default function CeteleTemplateCatalog({ value, onChange, disabled = false, autoFocus = false }) {
  return <>
    <Box role="group" aria-label="Şablon kataloğu" className="cetele-template-grid" sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2,minmax(0,1fr))',
      sm: 'repeat(3,minmax(0,1fr))' }, gap: 1, mb: 2 }}>
      {TEMPLATES.map(t => <Button key={t.id} type="button"
        autoFocus={autoFocus && value === t.id} aria-label={t.label} aria-pressed={value === t.id} variant="outlined" disabled={disabled}
        sx={{ ...action, minWidth: 0, minHeight: { xs: 108, sm: 148 },
          borderRadius: 3, p: 1.25, justifyContent: 'flex-start',
          bgcolor: value === t.id ? '#f7f3ff' : '#fff',
          borderColor: value === t.id ? '#7151d7' : '#dde4f1',
          color: '#17213c', textAlign: 'left', alignItems: 'flex-start',
          '&:hover': { borderColor: '#7151d7', bgcolor: '#f9f7ff' },
          '@media (max-height: 600px)': { minHeight: 116 } }}
        onClick={() => onChange(t.id)}>
        <Stack sx={{ width: '100%' }} gap={1}>
          <Typography className="cetele-template-icon" aria-hidden="true" sx={{ fontSize: 24, lineHeight: 1.2 }}>{t.icon}</Typography>
          <Typography className="cetele-template-label" sx={{ fontWeight: 700, fontSize: 13, lineHeight: 1.3, overflowWrap: 'anywhere' }}>
            {t.label}
          </Typography>
          <Typography className="cetele-template-description" sx={{ color: '#52617c', fontWeight: 500, fontSize: 11, lineHeight: 1.4 }}>
            {t.description}
          </Typography>
        </Stack>
      </Button>)}
    </Box>
    <Paper elevation={0} className="cetele-template-examples" sx={{ p: 1.5, border: '1px dashed #d8c7fa', borderRadius: 2,
      bgcolor: '#faf8ff', mb: 2 }}>
      <Typography sx={{ ...teacherTypography.metadata, fontSize: 12 }}>
        <strong>Örnek değerlendirme başlıkları:</strong> {TEMPLATES.find(t => t.id === value)?.examples}
      </Typography>
      <Typography sx={{ ...teacherTypography.supportingText, fontSize: 11, mt: 0.25 }}>
        Bunlar yalnızca öneri; otomatik değerlendirme oluşturulmaz.
      </Typography>
    </Paper>
  </>;
}
